import moment, { type Moment } from '@this/src/lib/moment';

const DEFAULT_FORMAT = 'YYYY-MM-DD';

export const formatDate = (date: Date | string | null, format = DEFAULT_FORMAT): string | undefined => {
  if (!date) return undefined;
  return moment(date).format(format);
};

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const formatWeekday = (date: Moment): string => date.format('ddd');

export const formatDateWithWeekday = (date: Date | string | null | undefined, format = 'M月D日'): string => {
  if (!date) return '-';

  const dateMoment = moment(date);
  return `${dateMoment.format(format)}(${formatWeekday(dateMoment)})`;
};

export const formatDateRangeWithWeekday = (
  start: Date | string | null | undefined,
  end: Date | string | null | undefined,
  format = 'M月D日',
  separator = '〜'
): string => {
  if (!start || !end) return '-';

  return `${formatDateWithWeekday(start, format)}${separator}${formatDateWithWeekday(end, format)}`;
};

export const addWeekdaysToDateText = (
  text: string | null | undefined,
  dates: Array<Date | string | null | undefined>
): string => {
  if (!text) return text ?? '';

  return dates
    .filter((date): date is Date | string => !!date)
    .reduce<string>((acc, date) => {
      const weekdayDate = moment(date);
      const dateText = weekdayDate.format('MM/DD');
      const weekdayText = formatWeekday(weekdayDate);
      return acc.replace(new RegExp(`${escapeRegExp(dateText)}(?!\\()`, 'g'), `${dateText}(${weekdayText})`);
    }, text ?? '');
};
